import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  RESTRICTED_SITE_ADMIN,
  SITE_ADMIN,
} from '../../../lib/utils/constants/UserTypes';

export default function Account({
  userType,
  setShowDropdown,
  showDropdown,
  dropdownRef,
}) {
  const { t } = useTranslation('header');
  const { clientAdminView } = useSelector(state => state.currentUser || {});

  return (
    <AccountWrapper
      id="accountDropdown"
      style={{ position: 'relative' }}
      onClick={() => setShowDropdown(state => !state)}
      data-tip="Account"
      data-for="Account"
    >
      <i className="fa-regular fa-circle-user fa-xl"></i>
      {showDropdown && (
        <List ref={dropdownRef}>
          <Option>
            <MenuLink href="/account/settings/edit">
              {t('account.settings')}
            </MenuLink>
          </Option>
          {[SITE_ADMIN, RESTRICTED_SITE_ADMIN].includes(userType) && (
            <>
              <Option>
                <MenuLink href="/admin">{t('account.siteAdmin')}</MenuLink>
              </Option>
              {!clientAdminView && (
                <Option>
                  <MenuLink href="/toggle_admin_view" data-method="post">
                    {t('account.clientAdminView')}
                  </MenuLink>
                </Option>
              )}
            </>
          )}
          {/* ClientAdmin::ChangelogsController only lets site admins in */}
          {userType === SITE_ADMIN && (
            <Option>
              <MenuLink href="/client_admin/changelog">
                {t('account.changelog')}
              </MenuLink>
            </Option>
          )}
          <SignOut>
            <MenuLink
              id="signOut"
              rel="nofollow"
              data-method="delete"
              href="/sign_out"
            >
              {t('account.signOut')}
            </MenuLink>
          </SignOut>
        </List>
      )}
    </AccountWrapper>
  );
}

const AccountWrapper = styled.div`
  display: none;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: block;
    cursor: pointer;
    border-radius: 40px;
    padding: 3px;
    &:hover {
      .fa-circle-user {
        color: ${themeGet('colors.black.60')};
      }
    }
  }
`;

const List = styled.ul`
  position: absolute;
  top: 51px;
  right: 0;
  border-radius: 8px;
  background: white;
  z-index: 4;
  width: 200px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  max-height: 80vh;
  overflow-y: auto;
`;

const Li = styled.li`
  cursor: pointer;
  width: 100%;

  &:hover {
    background: rgba(229, 242, 255, 0.5);
  }
`;

const Option = styled(Li)``;

const SignOut = styled(Li)`
  border-top: 1px solid ${themeGet('colors.black.20')};
`;

// <li> > <a>, with the padding on the link so the whole row stays clickable.
const MenuLink = styled.a`
  display: block;
  padding: 16px 20px;
  color: ${themeGet('colors.black.80')};

  &:hover,
  &:visited {
    color: ${themeGet('colors.black.80')};
  }

  &:focus-visible {
    outline: 2px solid ${themeGet('colors.primary.100')};
    outline-offset: -2px;
  }
`;
